import { projectRequest } from 'api';

export interface IRolePermission {
  name: string;
  action: string;
}

export interface IRole {
  id: string;
  deleted_at: string | null;
  name: string;
  is_admin: boolean;
  permissions: IRolePermission[];
}

const getRoleMe = async (): Promise<IRole> => {
  const response = await projectRequest(true).get('/role/me');
  return response.data;
};

export default getRoleMe;
